import { lazy } from 'react';

// dashboard-pages components
export const AccountSettingsPage = lazy(
  () => import('src/components/dashboard-pages/account-settings-page'),
);
export const AgentQA = lazy(
  () => import('src/components/dashboard-pages/agent-insights'),
);
export const AiQaPage = lazy(
  () => import('src/components/dashboard-pages/ai-qa-page'),
);
export const AgentQaSetupPage = lazy(
  () =>
    import('src/components/dashboard-pages/agent-insights/AgentQaSetupPage'),
);
export const AgentDetailPage = lazy(
  () =>
    import('src/components/dashboard-pages/agent-insights/detail/AgentDetailPage'),
);
export const AssistNotesPage = lazy(
  () => import('src/components/dashboard-pages/assist-notes-page'),
);
export const DiscoverAllTopicsPage = lazy(
  () => import('src/components/dashboard-pages/discover-all-topics-page'),
);
export const DiscoverAutomationPage = lazy(
  () => import('src/components/dashboard-pages/discover-automation-page'),
);
export const DiscoverPage = lazy(
  () => import('src/components/dashboard-pages/discover-dashboard-page'),
);
export const DiscoverInsightsPage = lazy(
  () => import('src/components/dashboard-pages/discover-insights-page'),
);
export const TopicDetailPage = lazy(
  () => import('src/components/dashboard-pages/discover-topic-detail-page'),
);
export const LookerDashboardPage = lazy(
  () =>
    import('src/components/dashboard-pages/embeddable-dashboards/LookerDashboard'),
);
export const HomePage = lazy(
  () => import('src/components/dashboard-pages/home-page'),
);
export const IntegrationsMain = lazy(
  () =>
    import('src/components/dashboard-pages/integrations-page/IntegrationsMain'),
);
export const SolveAgentTestingPage = lazy(
  () =>
    import('src/components/dashboard-pages/solve-agent-testing/SolveAgentTestingPage'),
);
export const SolveInsightsInsightCard = lazy(
  () => import('src/components/dashboard-pages/solve-insights/cards'),
);
export const SolveInsightsInsightCardView = lazy(
  () =>
    import('src/components/dashboard-pages/solve-insights/cards/view/SolveInsightsInsightCardView'),
);
export const SolveInsightsMain = lazy(
  () =>
    import('src/components/dashboard-pages/solve-insights/SolveInsightsMain'),
);
export const SolveInsightsArticleDetail = lazy(
  () => import('src/components/dashboard-pages/solve-insights-article-detail'),
);
export const SolveInsightsConversationRedirect = lazy(
  () =>
    import('src/components/dashboard-pages/solve-insights-conversation-redirect'),
);
export const SolveInsightsTopicDetail = lazy(
  () => import('src/components/dashboard-pages/solve-insights-topic-detail'),
);
export const SolveInsightsWorkflowDetail = lazy(() =>
  import('src/components/dashboard-pages/solve-insights-workflow-detail').then(
    module => ({ default: module.SolveInsightsWorkflowDetail }),
  ),
);
export const SSOSettingsPage = lazy(
  () => import('src/components/dashboard-pages/sso-settings-page'),
);
export const TeamSettingsPage = lazy(
  () => import('src/components/dashboard-pages/team-settings-page'),
);
export const TriageConfigDetailPage = lazy(
  () => import('src/components/dashboard-pages/triage-config-detail-page'),
);
export const TriageInsightsPage = lazy(
  () => import('src/components/dashboard-pages/triage-insights-page'),
);
export const TriageModelDetailPage = lazy(
  () => import('src/components/dashboard-pages/triage-model-detail-page'),
);
export const TriageModelsOverviewPage = lazy(
  () => import('src/components/dashboard-pages/triage-models-overview-page'),
);
export const TriageSimulationsDetailPage = lazy(
  () => import('src/components/dashboard-pages/triage-simulations-detail-page'),
);
export const TriageSimulationsPage = lazy(
  () => import('src/components/dashboard-pages/triage-simulations-page'),
);
export const TriageVersionControlDetail = lazy(
  () => import('src/components/dashboard-pages/triage-version-control-detail'),
);

// pages components
export const ActionBuilderPage = lazy(() => import('src/pages/action-builder'));
export const ActionBuilderDetailPage = lazy(
  () => import('src/pages/action-builder-detail/ActionBuilderDetailPage'),
);
export const AssistConfigurationPage = lazy(
  () => import('src/pages/assist-config'),
);
export const AssistInsightsAgentDetailPage = lazy(
  () => import('src/pages/assist-insights/agent-detail'),
);
export const AssistInsightsPage = lazy(
  () => import('src/pages/assist-insights'),
);
export const AssistPreviewPage = lazy(() => import('src/pages/assist-preview'));
export const AutonomousAgentPreview = lazy(
  () => import('src/pages/autonomous-agent-preview'),
);
export const BuilderParentPage = lazy(
  () => import('src/pages/builder-parent-page'),
);
export const EventsPage = lazy(() => import('src/pages/events/EventsPage'));
export const KnowledgePage = lazy(() =>
  import('src/pages/knowledge').then(module => ({
    default: module.KnowledgePage,
  })),
);
export const OrchestratorDetailPage = lazy(() =>
  import('src/pages/orchestrator/OrchestratorDetailPage').then(module => ({
    default: module.OrchestratorDetailPage,
  })),
);
export const OrchestratorLandingPage = lazy(() =>
  import('src/pages/orchestrator/OrchestratorLandingPage').then(module => ({
    default: module.OrchestratorLandingPage,
  })),
);
export const OrchestratorTestPage = lazy(() =>
  import('src/pages/orchestrator/OrchestratorTestPage').then(module => ({
    default: module.OrchestratorTestPage,
  })),
);
export const SubscriptionPlanPage = lazy(
  () => import('src/pages/plan/SubscriptionPlanPage'),
);
export const IntentTestDetailPage = lazy(
  () => import('src/pages/predict-intents/IntentTestDetailPage'),
);
export const PredictIntentsPage = lazy(
  () => import('src/pages/predict-intents/PredictIntentsPage'),
);
export const PIIRedactionSettingsPage = lazy(
  () => import('src/pages/security/PIIRedactionSettingsPage'),
);
export const SolveAnalyticsPageV2 = lazy(
  () => import('src/pages/solve-analytics'),
);
export const SolveConfigurationPage = lazy(
  () => import('src/pages/solve-config'),
);
export const SolvePreviewPage = lazy(
  () => import('src/pages/solve-config/preview/preview'),
);
export const ParentLandingPage = lazy(
  () => import('src/pages/workflow-builder/landing-page/ParentLandingPage'),
);
export const EmailPreviewPage = lazy(
  () => import('src/pages/workflow-builder-edit/email-preview-page'),
);
export const WorkflowPreviewPage = lazy(() =>
  import('src/pages/workflow-builder-preview/workflowPreviewPage').then(
    module => ({ default: module.WorkflowPreviewPage }),
  ),
);
